import useMainStore, { MainStoreType } from "../../stores/mainStore";

const newData: MainStoreType["data"] = {
    userID: "default",
    leftSidebarWidth: 300,
    leftSidebarCollapsed: false,
    openedNoteIDs: [],
    selectedNoteID: "",
    sortNotesBy: "Date Updated",
    loaded: false,
    sortNotesNewToOld: false,
    filterString: "",
    showTableOfContents: false,
    sortFoldersBy: "Date Updated",
    sortFoldersNewToOld: false,
};

const dbName = "mainStore";
const defaultName = "default";

function openDB(): Promise<IDBDatabase> {
    return new Promise((resolve, reject) => {
        const request = indexedDB.open(dbName, 1);
        request.onupgradeneeded = () => {
            const db = request.result;
            if (!db.objectStoreNames.contains(defaultName)) {
                db.createObjectStore(defaultName);
            }
        };
        request.onsuccess = () => resolve(request.result);
        request.onerror = () => reject(request.error);
    });
}

export async function saveMainStore(userID?: string) {
    const id = userID || defaultName;
    const storeData_ = useMainStore.getState().data;    

    // If userID === id && isn't "default", allow save
    if ( storeData_.userID !== id && id !== defaultName) {
        console.warn("saveMainStore: UserID mismatch.");
        return;
    }
    // If id is "default" and userID is NOT undefined (saving incorrect data)
    else if(id === defaultName && storeData_.userID !== undefined) {
        console.warn("saveMainStore: Incorrect userID.");
        return;
    }

    // Get the data from the store
    const storeData = { ...storeData_, userID: id };
    const dataString = JSON.stringify(storeData);

    // Save the data to IndexedDB
    const db = await openDB();
    const tx = db.transaction(defaultName, "readwrite");
    tx.objectStore(defaultName).put(dataString, id);
    return await new Promise((resolve, reject) => {
        tx.oncomplete = resolve;
        tx.onerror = reject;
    });
}

export async function loadMainStore(userID?: string): Promise<string> {
    const id = userID || defaultName;

    const db = await openDB();

    return new Promise((resolve, reject) => {
        const tx = db.transaction(defaultName, "readonly");
        const request = tx.objectStore(defaultName).get(id);
        request.onsuccess = () =>
            resolve(request.result ? request.result : JSON.stringify(newData));
        request.onerror = () => reject(request.error);
    });
}
